import { jwtDecode } from 'jwt-decode';

import { AccessTokenPayloadSchema } from './jwt.schema';

export class JwtDecoder {
  public static decodeAccessToken(accessToken: string) {
    const decodedTokens = jwtDecode(accessToken);

    return AccessTokenPayloadSchema.safeParse(decodedTokens);
  }
}
